import { useMemo } from 'react';
import type { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';

export type GroupedType = {
    episodeCategories: Set<string>;
    ids: string[];
    name: string;
    sortOrder: number;
};

type GroupedTypes = Record<string, GroupedType[]>;

export function useGroupedTypes(types: OutpatientClinicTask['type'][]) {
    return useMemo(() => {
        return types.reduce((acc, type) => {
            const groupName = type.group.name;
            if (!acc[groupName]) {
                acc[groupName] = [];
            }

            const existingType = acc[groupName].find((t) => t.name === type.name);
            if (existingType) {
                existingType.ids.push(type.id);
                existingType.episodeCategories.add(type.group.episodeCategory.name);
            } else {
                acc[groupName].push({
                    episodeCategories: new Set([type.group.episodeCategory.name]),
                    ids: [type.id],
                    name: type.name,
                    sortOrder: type.sortOrder,
                });
            }

            return acc;
        }, {} as GroupedTypes);
    }, [types]);
}
